import loadable from '@loadable/component';
import { WithLazyHydration } from '../WithLazyHydration';

const RecommendationLoadable = loadable(() => import('./Recommendation'), {
  resolveComponent: components => components.Recommendation
});

export const Recommendation = WithLazyHydration(RecommendationLoadable, {
  name: 'Recommendation'
});
